export default __webpack_public_path__ + "static/media/U.71f13927.svg";